import {
  SectionElement,
  defineElement,
  globalOn,
  query,
  wait
} from "./chunk-POAMU4SL.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/shop-popup-modal/shop-popup-modal.ts
var ShopPopupModal = class extends SectionElement {
  get delay() {
    var _a;
    return parseInt((_a = this.getAttribute("data-delay")) != null ? _a : "0");
  }
  get reshow() {
    var _a;
    return parseInt((_a = this.getAttribute("data-reshow")) != null ? _a : "0");
  }
  connectedCallback() {
    if (this.shouldShowPopup()) {
      this.setPopupStatus();
    }
    document.addEventListener("click", (e) => {
      var _a, _b;
      const composedPath = e.composedPath();
      for (const elm of composedPath) {
        if (elm instanceof HTMLAnchorElement && ((_a = elm.href) == null ? void 0 : _a.includes(this.popupModal.dataset.identifier))) {
          e.preventDefault();
          (_b = this.popupModal) == null ? void 0 : _b.open();
        }
      }
    });
  }
  setPopupStatus() {
    return __async(this, null, function* () {
      var _a;
      yield wait(this.delay * 1e3);
      (_a = this.popupModal) == null ? void 0 : _a.open();
      const expirationDate = (/* @__PURE__ */ new Date()).getTime() + this.reshow * 60 * 60 * 1e3;
      localStorage.setItem("popupShown", JSON.stringify({ shown: true, expirationDate }));
    });
  }
  debugOpen(_elm, event) {
    var _a;
    const sectionId = this.getAttribute("data-section-id");
    if (sectionId === event.detail.sectionId) {
      (_a = this.popupModal) == null ? void 0 : _a.open();
    }
  }
  debugClose(_elm, event) {
    var _a;
    const sectionId = this.getAttribute("data-section-id");
    if (sectionId === event.detail.sectionId) {
      (_a = this.popupModal) == null ? void 0 : _a.close();
    }
  }
  shouldShowPopup() {
    var _a;
    if (((_a = this.popupModal) == null ? void 0 : _a.getAttribute("data-pageload")) !== "true") {
      return false;
    }
    const popupData = localStorage.getItem("popupShown");
    if (popupData != null) {
      const { shown, expirationDate } = JSON.parse(popupData);
      if (Boolean(shown) && (/* @__PURE__ */ new Date()).getTime() < expirationDate) {
        return false;
      }
    }
    return true;
  }
};
__decorateClass([
  query("[popup-modal]")
], ShopPopupModal.prototype, "popupModal", 2);
__decorateClass([
  globalOn("shopify:section:select")
], ShopPopupModal.prototype, "debugOpen", 1);
__decorateClass([
  globalOn("shopify:section:deselect")
], ShopPopupModal.prototype, "debugClose", 1);
ShopPopupModal = __decorateClass([
  defineElement("shop-popup-modal")
], ShopPopupModal);
export {
  ShopPopupModal
};
